<template>
  <div class="wraper">
    <header class="headerWrapper">
      <div class="header">
        <div class="logo" ref="logo">工单管理系统</div>
        <div class="right">
          <div class="header-set">
            <!-- <el-tooltip effect="dark" content="切换主题" placement="bottom">
                            <m-skin class="theme-switch right-menu-item"></m-skin>
                        </el-tooltip> -->
            <p trigger="click" @command="menuCommand">
              <span
                class="el-text"
                style="font-size: 16px; color: #333; margin-left: 20px"
              >
                {{ userInfo.realName }}
                <!-- <i style="margin-left:15px" class="el-icon-arrow-down el-icon--right"></i> -->
              </span>
              <!-- <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                            </el-dropdown-menu> -->
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section">
      <div class="nav navbar" :style="`background:${navColor}`">
        <!--<el-menu :default-active="getNames($route.name)" class="el-menu-vertical-demo" :router="true" :background-color="navColor" text-color="#333" :active-text-color="activeColor">
                    <el-submenu v-for="menu of navs" :index="menu.menuName" :key="menu.path">
                        <template slot="title">
                            <i v-if="menu.icon" :class="menu.icon" class="tab-icon"></i>
                            <i class="el-icon-help" v-else></i>
                            <span>{{menu.menuName || '未添加title了'}}</span>
                        </template>
                        <el-menu-item-group>
                            <template v-for="child of menu.submenuList">
                                <el-menu-item v-if="child.isShow && !child.isExternal" :key="child.path" :index="getNames(child.menuUrl,1)" :route="{name: child.menuUrl}">{{child.menuName || '未添加title'}}
                                </el-menu-item>
                                <el-menu-item v-if="child.isExternal" :key="child.path">{{child.menuName || '未添加title'}}
                                </el-menu-item>
                            </template>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>-->
        <el-menu
          :default-active="getNames($route.name)"
          class="el-menu-vertical-demo"
          :router="true"
          :background-color="navColor"
          text-color="#333"
          :active-text-color="activeColor"
        >
          <el-menu-item
            :index="getNames('work.index.homeIndex')"
            :route="{ name: 'work.index.homeIndex' }"
          >
            <template slot="title">
              <i class="el-icon-rank"></i>
              <span>工单首页</span>
            </template>
          </el-menu-item>
          <el-submenu
            v-for="(menu, index) of menus"
            :index="menu.name"
            :key="menu.path"
          >
            <template slot="title">
              <!--                            <i v-if="menu.icon" :class="menu.icon" class="tab-icon"></i>-->
              <!--                            <i class="el-icon-help" v-else></i>-->
              <i :class="iconClass[index]"></i>
              <span>{{ menu.meta.title || "未添加title了" }}</span>
            </template>
            <el-menu-item-group>
              <template v-for="child of menu.children">
                <template v-if="child.meta.isShow">
                  <el-menu-item
                    :key="child.path"
                    :index="getNames(child.name, 1)"
                    style="padding-left: 49px"
                    :route="{ name: child.name }"
                    >{{ child.meta.title || "未添加title" }}
                  </el-menu-item>
                  <el-menu-item v-if="child.isExternal" :key="child.path"
                    >{{ child.meta.title || "未添加title" }}
                  </el-menu-item>
                </template>
              </template>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <section ref="mainContent" class="main-content">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </section>
    </section>
  </div>
</template>
<script>
import selfLeftMenu from "components/selfLeftMenu";
import phone from "components/phone";
import api from "plus/api";
import skin from "components/skin/index";
import { mapState, mapActions } from "vuex";
import router from "../router";
import config from "plus/config";

export default {
  data() {
    const item = {
      date: "2016-05-02",
      name: "王小虎",
      address: "上海市普陀区金沙江路 1518 弄",
    };
    return {
      myPhone: "123889888",
      tableData: Array(20).fill(item),
      navColor: "#fff",
      activeColor: "#3572e2",
      iconClass: [
        "el-icon-reading",
        "el-icon-wallet",
        "el-icon-suitcase",
        "el-icon-user",
      ],

      navs: [
        {
          id: 10,
          menuCode: "GDZX",
          menuName: "工单中心",
          menuLevel: 1,
          orderNumber: 2,
          isEnable: true,
          menuUrl: "work",
          description: "",
          parentMenuCode: null,
          parentMenuId: null,
          isShow: true,
          isCache: true,
          icon: "el-icon-s-home",
          submenuList: [
            {
              id: 10,
              menuCode: "GDSY",
              menuName: "工单首页",
              menuLevel: 2,
              orderNumber: 0,
              isEnable: true,
              menuUrl: "work.workIndexPage",
              description: "",
              parentMenuCode: "GDZX",
              parentMenuId: 10,
              isShow: true,
              isCache: false,
              icon: "",
              submenuList: null,
            },
            {
              id: 11,
              menuCode: "GDTJ",
              menuName: "工单提交",
              menuLevel: 2,
              orderNumber: 0,
              isEnable: true,
              menuUrl: "work.list",
              description: "",
              parentMenuCode: "GDZX",
              parentMenuId: 10,
              isShow: true,
              isCache: false,
              icon: "",
              submenuList: null,
            },
            {
              id: 11,
              menuCode: "GDTJ",
              menuName: "提交详情",
              menuLevel: 2,
              orderNumber: 0,
              isEnable: true,
              menuUrl: "work.details",
              description: "",
              parentMenuCode: "TJXQ",
              parentMenuId: 10,
              isShow: false,
              isCache: false,
              icon: "",
              submenuList: null,
            },
          ],
        },
        {
          id: 9,
          menuCode: "QXGL",
          menuName: "管理",
          menuLevel: 1,
          orderNumber: 2,
          isEnable: true,
          menuUrl: "privilege",
          description: "",
          parentMenuCode: null,
          parentMenuId: null,
          isShow: true,
          isCache: true,
          icon: "el-icon-s-operation",
          submenuList: [
            {
              id: 10,
              menuCode: "CDGL",
              menuName: "page1",
              menuLevel: 2,
              orderNumber: 0,
              isEnable: true,
              menuUrl: "homepage",
              description: "",
              parentMenuCode: "QXGL",
              parentMenuId: 9,
              isShow: true,
              isCache: false,
              icon: "",
              submenuList: null,
            },

            {
              id: 12,
              menuCode: "CDXGL",
              menuName: "page2",
              menuLevel: 2,
              orderNumber: 0,
              isEnable: true,
              menuUrl: "homepage",
              description: "",
              parentMenuCode: "QXGL",
              parentMenuId: 9,
              isShow: true,
              isCache: true,
              icon: "",
              submenuList: null,
            },
          ],
        },
        {
          id: 10,
          menuCode: "demo",
          menuName: "demo",
          menuLevel: 3,
          orderNumber: 3,
          isEnable: true,
          menuUrl: "demo",
          description: "",
          parentMenuCode: null,
          parentMenuId: null,
          isShow: true,
          isCache: true,
          icon: "el-icon-s-operation",
          submenuList: [
            {
              id: 10,
              menuCode: "lb",
              menuName: "列表",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "demo.list",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
          ],
        },
        {
          id: 10,
          menuCode: "privilege",
          menuName: "管理中心",
          menuLevel: 3,
          orderNumber: 3,
          isEnable: true,
          menuUrl: "privilege",
          description: "",
          parentMenuCode: null,
          parentMenuId: null,
          isShow: true,
          isCache: true,
          icon: "el-icon-s-operation",
          submenuList: [
            {
              id: 10,
              menuCode: "lb",
              menuName: "菜单管理",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "privilege.menu.list",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
            {
              id: 10,
              menuCode: "rygl",
              menuName: "人员管理",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "privilege.user.list",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
            {
              id: 11,
              menuCode: "lb",
              menuName: "角色管理",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "privilege.role.list",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
            {
              id: 10,
              menuCode: "yhzgl",
              menuName: "用户组管理",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "privilege.userGroup.list",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
          ],
        },
        {
          id: 10,
          menuCode: "GDGL",
          menuName: "工单管理",
          menuLevel: 3,
          orderNumber: 3,
          isEnable: true,
          menuUrl: "workmange",
          description: "",
          parentMenuCode: null,
          parentMenuId: null,
          isShow: true,
          isCache: true,
          icon: "el-icon-s-operation",
          submenuList: [
            {
              id: 10,
              menuCode: "gdlb",
              menuName: "工单列表",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "workmange.workOrderList",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
            {
              id: 10,
              menuCode: "gdzj",
              menuName: "工单质检",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "workmange.workQuality.list",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
            {
              id: 12,
              menuCode: "zjsz",
              menuName: "质检设置",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "workmange.workQualitySetting.setting",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
          ],
        },
        {
          id: 10,
          menuCode: "YHDLGL",
          menuName: "用户登录管理",
          menuLevel: 3,
          orderNumber: 3,
          isEnable: true,
          menuUrl: "usermange",
          description: "",
          parentMenuCode: null,
          parentMenuId: null,
          isShow: true,
          isCache: true,
          icon: "el-icon-s-operation",
          submenuList: [
            {
              id: 10,
              menuCode: "gdlb",
              menuName: "用户登录管理",
              menuLevel: 3,
              orderNumber: 3,
              isEnable: true,
              menuUrl: "usermange.loginManage",
              description: "",
              parentMenuCode: null,
              parentMenuId: null,
              isShow: true,
              isCache: true,
              icon: "el-icon-s-operation",
            },
          ],
        },
      ],
    };
  },
  components: {
    "m-skin": skin,
    "m-phone": phone,
    "self-left-menu": selfLeftMenu,
  },
  created() {
    // this.getArea();
    // this.getMenList();
  },
  activated() {},
  deactivated() {},
  computed: {
    ...mapState(["themeValue", "menus", "userInfo"]),
  },
  watch: {
    themeValue(val) {
      this.changeStyle(val);
    },
    menus() {},
  },
  methods: {
    ...mapActions(["updateToken"]),
    menuCommand(command) {
      if (command === "logout") {
        api.log.logOut().then((res) => {
          this.updateToken("");
          window.location.replace(config.UC_HOST);
        });
      }
    },
    getMenList() {
      return api.login
        .getLoginInfo()
        .then((q) => {})
        .catch((e) => {
          // 获取用户信息失败
          setTimeout(() => {
            window.location.href = process.env.VUE_APP_UC;
          }, 1000);
        });
    },
    getArea() {
      return api.login.areas().then((q) => {
        if (q.data.success) {
          this.apiCityData = q.data.data;
          this.hotCity = q.data.data.hotCity;
          this.areaList = q.data.data.data;
          this.areaCity = this.hotCity;
        }
      });
    },
    changeStyle(val) {
      switch (val) {
        case "Blue":
          this.navColor = "#409eff";
          this.activeColor = "#FFD042";
          break;
        case "Green":
          this.navColor = "#009a61";
          this.activeColor = "#CCFF33";
          break;
        case "Red":
          this.navColor = "#f44336";
          this.activeColor = "#ffbf40";
          break;
        case "Purple":
          this.navColor = "#6959CD";
          this.activeColor = "#ff9340";
          break;
        default:
          this.navColor = "#545c64";
          this.activeColor = "#ffd04b";
          break;
      }
    },
    getNames(val, param) {
      let num = val.split(".");
      if (num.length >= 2) return num[0] + num[1];
      else return num[0];
    },
  },
};
</script>
<style lang="less" scoped>
.headerWrapper {
  width: 100%;
  background: #fff;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  box-shadow: 0px 3px 13px 0px rgba(0, 88, 255, 0.18);
}

.header {
  height: 74px;
  color: #000;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .right {
    height: 100%;
    padding-right: 20px;
    flex: 1;
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #dcdfe6;
  }

  .logo {
    width: 200px;
    // height: 100%; //color: #fff;
    line-height: 74px;
    text-align: center; //background-color: #42494f;
    color: #fdfdfd;
    font-size: 18px;
    background: linear-gradient(317deg, #236cff, #4a9bff 98%);
  }

  img {
    width: 230px;
  }
}

.wraper {
  padding-top: 74px;
  margin: 0 auto;
}

.nav {
  width: 200px;
  height: calc(~"100vh - 60px"); //background-color: #545c64;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 74px;
  bottom: 0;
  z-index: 999;
  box-shadow: 0px 3px 13px 0px rgba(0, 88, 255, 0.18);
}

.header-set {
  display: flex;
  align-items: center;
}

.menu-icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
